import React, { Component } from 'react';
import './style.scss';
import PropTypes from 'prop-types';
import TopicContent from '../topicContent';
import TalkContent from '../talkContent';
import QAWorkPanel from '../QAWorkPanel'

class Section extends Component {


    constructor(props){
        super(props);
        this.state={
            collapse: false
        }
    }

    triggerCollapse(e){
        e.preventDefault();
        this.setState({
            collapse: !this.state.collapse
        })
    }

    renderTopicContent(topicContent, label) {
        return (
            <>
                <TopicContent className={"section-topic"} content={topicContent} />
            </>
        )
    }

    renderTalkContent(talkContent, label) {
        return (
            <>
                <TalkContent className={"section-topic"} content={talkContent} />
            </>
        )
    }


    renderQuestions(QAs, showHideButton=false) {
        if(showHideButton){
            let className = this.state.collapse ? " ":"workPanelHide";
            return (
                <>
                    <a className="show-questions-button" href="#" onClick={(e)=>this.triggerCollapse(e)}>{this.state.collapse ? "Hide Follow Up Questions" : "Show Follow Up Questions"} <b>Tap Here</b></a>
                    <QAWorkPanel QAs={QAs} className={className}/>
                </>)
        }else{
            return <QAWorkPanel QAs={QAs} />
        }

    }



    render() {
        if (this.props.section) {
            const { QAs, label, content, talkContent } = this.props.section;
            return (
                <div className="section">
                    {content && this.renderTopicContent(content, label)}
                    {talkContent && this.renderTalkContent(talkContent, label)}
                    {this.renderQuestions(QAs, this.props.showHideButton)}
                </div>
            );
        } else {
            return (
                <div>Empty</div>
            )
        }
    }
}


Section.propTypes = {
    section: PropTypes.object.isRequired,
};

export default Section;
